import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError('');
      await login(email, password);
      navigate('/', { replace: true });
    } catch (err) {
      if (err?.code === 'SESSION_EXPIRED' || err?.message === 'SESSION_EXPIRED') return;
      setError(err?.message || 'No se pudo iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="container"
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        padding: 16,
        background:
          'radial-gradient(1200px 600px at 10% -10%, #eef2ff 0%, transparent 40%), radial-gradient(1000px 500px at 110% -20%, #f0fdfa 0%, transparent 45%)'
      }}
    >
      <div
        className="card"
        style={{
          width: '100%',
          maxWidth: 420,
          borderRadius: 16,
          padding: 20,
          border: '1px solid #edf1f7',
          boxShadow: '0 6px 30px rgba(0,0,0,0.06)',
          background: '#fff'
        }}
      >
        <h1 style={{ margin: 0, marginBottom: 12 }}>Ingreso</h1>

        {error && (
          <div
            role="alert"
            style={{
              background: '#fff3f3',
              border: '1px solid #ffd6d6',
              color: '#a40000',
              padding: '10px 12px',
              borderRadius: 10,
              marginBottom: 12,
              fontSize: 14
            }}
          >
            {error}
          </div>
        )}

        <form onSubmit={onSubmit} style={{ display: 'grid', gap: 10 }}>
          <label htmlFor="email" style={{ fontSize: 14, color: '#374151' }}>Email</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading}
            style={{
              height: 40,
              borderRadius: 10,
              border: '1px solid #e5e7eb',
              padding: '0 12px',
              outline: 'none',
              fontSize: 14,
              boxShadow: 'inset 0 0 0 1px transparent'
            }}
            onFocus={(e)=>{ e.currentTarget.style.boxShadow='inset 0 0 0 1px #111827'; }}
            onBlur={(e)=>{ e.currentTarget.style.boxShadow='inset 0 0 0 1px transparent'; }}
          />

          <label htmlFor="password" style={{ fontSize: 14, color: '#374151' }}>Password</label>
          <div
            style={{
              position: 'relative',
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <input
              id="password"
              type={showPwd ? 'text' : 'password'}
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              style={{
                height: 40,
                borderRadius: 10,
                border: '1px solid #e5e7eb',
                padding: '0 44px 0 12px',
                outline: 'none',
                width: '100%',
                fontSize: 14,
                boxShadow: 'inset 0 0 0 1px transparent'
              }}
              onFocus={(e)=>{ e.currentTarget.style.boxShadow='inset 0 0 0 1px #111827'; }}
              onBlur={(e)=>{ e.currentTarget.style.boxShadow='inset 0 0 0 1px transparent'; }}
            />
            <button
              type="button"
              onClick={() => setShowPwd(v => !v)}
              aria-label={showPwd ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              disabled={loading}
              style={{
                position: 'absolute',
                right: 6,
                height: 28,
                borderRadius: 8,
                border: '1px solid #e5e7eb',
                background: '#f9fafb',
                padding: '0 8px',
                fontSize: 12,
                cursor: 'pointer'
              }}
            >
              {showPwd ? 'Ocultar' : 'Mostrar'}
            </button>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 2 }}>
            <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#4b5563' }}>
              <input type="checkbox" disabled={loading} /> Recuérdame
            </label>
          </div>

          <button
            className="btn"
            disabled={loading}
            aria-busy={loading}
            style={{
              marginTop: 6,
              height: 42,
              borderRadius: 10,
              border: '1px solid #0b1220',
              background: loading
                ? 'linear-gradient(180deg, #0f172a 0%, #0b1220 100%)'
                : 'linear-gradient(180deg, #111827 0%, #0b1220 100%)',
              color: '#fff',
              fontWeight: 600,
              letterSpacing: .2,
              cursor: loading ? 'default' : 'pointer',
              opacity: loading ? .8 : 1
            }}
          >
            {loading ? 'Ingresando…' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
